
import { AUTH_ACTION_TYPES } from './auth.types';

import {
    Action,
    ActionWithPayload,
    createAction,
    withMatcher,
} from '../../utils/reducer/reducer.utils';

export type SignInStart = ActionWithPayload<
    AUTH_ACTION_TYPES.SIGN_IN_START,
    { email: string; password: string; onComplete: () => void; }
>;

export type SignInSuccess = ActionWithPayload<
    AUTH_ACTION_TYPES.SIGN_IN_SUCCESS,
    { accessToken: string; }
>;

export type SignInFailed = ActionWithPayload<
    AUTH_ACTION_TYPES.SIGN_IN_FAILED,
    string
>;

export type SignOut = Action<AUTH_ACTION_TYPES.SIGN_OUT>;


export const signInStart = withMatcher(
    (email: string, password: string, onComplete: () => void): SignInStart =>
        createAction(AUTH_ACTION_TYPES.SIGN_IN_START, { email, password, onComplete })
);

export const signInSuccess = withMatcher(
    (accessToken: string): SignInSuccess =>
        createAction(AUTH_ACTION_TYPES.SIGN_IN_SUCCESS, { accessToken })
);

export const signInFailed = withMatcher(
    (error: string): SignInFailed =>
        createAction(AUTH_ACTION_TYPES.SIGN_IN_FAILED, error)
);

export const signOut = withMatcher(
    (): SignOut => createAction(AUTH_ACTION_TYPES.SIGN_OUT)
);
